module.exports = __webpack_public_path__ + "static/902-036b0fa4f78e6a76db6137864d829703.png";